
import { HTTPClient } from "./Client";

const GrupoDeUsuarioFuncionalidade = {
    async AtualizarGrupoDeUsuarioFuncionalidadeAPI(grupoDeUsuarioId, funcionalidadesId) {
        try {

            const atualizar = {
                funcionalidades: funcionalidadesId.map(String)
            }
            const response = await HTTPClient.put(`/GrupoDeUsuarioFuncionalidade/Atualizar/${grupoDeUsuarioId}`,
                atualizar
            );

            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar um grupo de usuario funcionalidade:", error)
            throw error;
        }
    },

    async ObterGrupoDeUsuarioFuncionalidadeAsync(grupoDeUsuarioId) {
        try {
            const response = await HTTPClient.get(
                `/GrupoDeUsuarioFuncionalidade/${grupoDeUsuarioId}`
            );

            return response.data;
        } catch (error) {
            console.error("Erro ao obter as funcionalidades do grupo de usuario:", error);
            throw error;
        }
    },


}

export default GrupoDeUsuarioFuncionalidade;